import { Navigate, Outlet, useLocation } from "react-router-dom";

const PrivateRoutes = () => {
  const accessToken = sessionStorage.getItem("accessToken");
  const location = useLocation();

  if (!accessToken) {
    const currentUrl = `${location.pathname}${location.search}`;
    const encodedRedirectUrl = encodeURIComponent(currentUrl);
    return <Navigate to={`/sign-in?redirect_to=${encodedRedirectUrl}`} />;
  }

  return <Outlet />;
};

export default PrivateRoutes;
